export default function (state = null, action) {
    switch (action.type) {
        case 'CLEAR_CRUISES':
            return null;

        case 'SET_CRUISES':
            return { ...state, cruiseDetails: action.cruises, cruiseStartDate: action.cruiseStartDate};


        case 'SET_CRUISE_IMAGE_REFERENCE':
            return { ...state, imageReferenceId: action.imageReferenceId};

        default:
            return state;
    }
}
